import * as Yup from 'yup';
import { getProductShape } from 'validators/Common/baseJustificationValidator';

export class UpdateJustificationValidator {
  public get schema() {
    return Yup.object().shape({
      ...getProductShape()
    });
  }
}
